// Array estatico: pasar `libraries: [...]` inline crea un array nuevo en cada render y
// hace que useJsApiLoader avise "LoadScript has been reloaded unintentionally".
export const GOOGLE_MAPS_LIBRARIES = ["places"];
